module.exports = __webpack_public_path__ + "static/sport/footer-banner4.5b1a999.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport8/footer-banner4.png
// module id = Ab+M
// module chunks = 0